// extracted by mini-css-extract-plugin
export var printerCard = "_c9-1";
export var printerCardConfigured = "_c9-2";
export var printerCardError = "_c9-3";
export var printerCardsContainer = "_c9-0";
export var printerIcon = "_c9-8";
export var printerIconConfigured = "_c9-5";
export var printerIconContainer = "_c9-4";
export var printerIconError = "_c9-6";
export var printerIconUnconfigured = "_c9-7";
export var workstationsTableCard = "_c9-9";